var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "breadcrumbs ace-save-state",
        attrs: { id: "breadcrumbs" }
      },
      [
        _c(
          "ul",
          { staticClass: "breadcrumb" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "router-link",
              {
                attrs: {
                  tag: "li",
                  to: { name: "groupedit", query: { id: _vm.groupId } }
                }
              },
              [_c("a", [_vm._v("ゲートグループ編集")])]
            ),
            _vm._v(" "),
            _c("li", { staticClass: "active" }, [
              _vm._v("ゲートの関連付けを追加")
            ])
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("label", { staticClass: "checkbox-box" }, [
          _c("input", {
            staticClass: "ace gateId",
            attrs: { name: "scorp", type: "checkbox", checked: "checked" },
            on: {
              click: function($event) {
                _vm.addRomoveScorp("gateId", "gateId")
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "lbl" }, [_vm._v("ゲートID")])
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "checkbox-box" }, [
          _c("input", {
            staticClass: "ace gateName",
            attrs: { name: "scorp", type: "checkbox", checked: "checked" },
            on: {
              click: function($event) {
                _vm.addRomoveScorp("gateName", "gateName")
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "lbl" }, [_vm._v("ゲート名")])
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "checkbox-box" }, [
          _c("input", {
            staticClass: "ace gateModelName",
            attrs: { name: "scorp", type: "checkbox", checked: "checked" },
            on: {
              click: function($event) {
                _vm.addRomoveScorp("gateModelName", "gateModelName")
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "lbl" }, [_vm._v("製品名")])
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "checkbox-box" }, [
          _c("input", {
            staticClass: "ace option1",
            attrs: { name: "scorp", type: "checkbox", checked: "checked" },
            on: {
              click: function($event) {
                _vm.addRomoveScorp("option1", "option1")
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "lbl" }, [_vm._v("備考.1")])
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "checkbox-box" }, [
          _c("input", {
            staticClass: "ace option2",
            attrs: { name: "scorp", type: "checkbox", checked: "checked" },
            on: {
              click: function($event) {
                _vm.addRomoveScorp("option2", "option2")
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "lbl" }, [_vm._v("備考.2")])
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-cusstom green-btn",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.search()
              }
            }
          },
          [_vm._v("検索")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-cusstom green-btn",
            attrs: { type: "button", href: "#process", "data-toggle": "modal" },
            on: {
              click: function($event) {
                _vm.resetStatus()
              }
            }
          },
          [_vm._v("チェックしたゲートを追加する")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-cusstom black-btn pull-right",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.cancel()
              }
            }
          },
          [_vm._v("ゲートグループ編集画面に戻る")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "page-content" }, [
      _vm.errorMessageLogs !== ""
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _vm._v("\n    " + _vm._s(_vm.errorMessageLogs) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { attrs: { id: "loading" } }, [
            _c("div", { staticClass: "loadingMsg" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "scroll-data-content" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "clearfix", staticStyle: { clear: "both" } }, [
          _c("div", { attrs: { id: "accordion" } }, [
            _c(
              "div",
              {
                staticClass: "panel-collapse collapse",
                staticStyle: { height: "0px" },
                attrs: { id: "collapseOne", "aria-expanded": "false" }
              },
              [
                _c("div", { staticClass: "panel-body" }, [
                  _c("div", { staticClass: "control-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label bolder blue display_block"
                      },
                      [_vm._v("表示項目")]
                    ),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "gateName",
                            type: "checkbox",
                            checked: "",
                            value: "gateName"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "gateName") > -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "gateName",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [_vm._v("ゲート名")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "gateModelName",
                            type: "checkbox",
                            checked: "",
                            value: "productName"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "productName") >
                                -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "productName",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [_vm._v("製品名")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "option1",
                            type: "checkbox",
                            checked: "",
                            value: "option1"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "option1") > -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "option1",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [_vm._v("備考.1")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox table_items" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedColumnNames,
                              expression: "checkedColumnNames"
                            }
                          ],
                          staticClass: "ace",
                          attrs: {
                            name: "option2",
                            type: "checkbox",
                            checked: "",
                            value: "option2"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.checkedColumnNames)
                              ? _vm._i(_vm.checkedColumnNames, "option2") > -1
                              : _vm.checkedColumnNames
                          },
                          on: {
                            click: _vm.ShowHideColumn,
                            change: function($event) {
                              var $$a = _vm.checkedColumnNames,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "option2",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedColumnNames = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedColumnNames = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedColumnNames = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" }, [_vm._v("備考.2")])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "control-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label bolder blue display_block"
                      },
                      [_vm._v("ページごとに表示する項目数")]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selected,
                            expression: "selected"
                          }
                        ],
                        staticClass: "first-child last-child",
                        attrs: { id: "pageSizeOptions" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selected = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            _vm.handleSizeChange
                          ]
                        }
                      },
                      _vm._l(_vm.pageSizeOptions, function(pageSize) {
                        return _c(
                          "option",
                          { key: pageSize, domProps: { value: pageSize } },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(pageSize) +
                                " 件\n                  "
                            )
                          ]
                        )
                      })
                    )
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm.list != null
          ? _c(
              "table",
              {
                staticClass: "table  table-bordered table-hover dataTable",
                attrs: { id: "simple-table" }
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", { staticClass: "center" }, [
                      _c("label", { staticClass: "pos-rel" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectAll,
                              expression: "selectAll"
                            }
                          ],
                          staticClass: "ace",
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.selectAll)
                              ? _vm._i(_vm.selectAll, null) > -1
                              : _vm.selectAll
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.selectAll,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selectAll = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selectAll = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" })
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "gateId sorting",
                        attrs: { id: "gateId" },
                        on: {
                          click: function($event) {
                            _vm.sort("gateId", "gateId")
                          }
                        }
                      },
                      [_vm._v("ゲートID")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "gateModelName sorting",
                        class: { none: _vm.checkColumnShowHide("productName") },
                        attrs: { id: "gateModelName" },
                        on: {
                          click: function($event) {
                            _vm.sort("gateModelName", "gateModelName")
                          }
                        }
                      },
                      [_vm._v("製品名")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "gateName sorting",
                        class: { none: _vm.checkColumnShowHide("gateName") },
                        attrs: { id: "gateName" },
                        on: {
                          click: function($event) {
                            _vm.sort("gateName", "gateName")
                          }
                        }
                      },
                      [_vm._v("ゲート名")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "option1 sorting",
                        class: { none: _vm.checkColumnShowHide("option1") },
                        attrs: { id: "option1" },
                        on: {
                          click: function($event) {
                            _vm.sort("option1", "option1")
                          }
                        }
                      },
                      [_vm._v("備考.1")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "option2 sorting",
                        class: { none: _vm.checkColumnShowHide("option2") },
                        attrs: { id: "option2" },
                        on: {
                          click: function($event) {
                            _vm.sort("option2", "option2")
                          }
                        }
                      },
                      [_vm._v("備考.2")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { "text-align": "center", width: "100px" }
                      },
                      [_vm._v("アクション")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._l(_vm.list, function(item, index) {
                  return _c("tbody", { key: index }, [
                    _vm.rowSelectedExistUser(item.gateId)
                      ? _c(
                          "tr",
                          {
                            staticClass: "existItem",
                            class: {
                              selected: _vm.rowSelectedExistUser(item.gateId)
                            },
                            attrs: { id: item.gateId }
                          },
                          [
                            _c("td", { staticClass: "center" }, [
                              _c("label", { staticClass: "pos-rel" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.existGateId,
                                      expression: "existGateId"
                                    }
                                  ],
                                  staticClass: "ace",
                                  attrs: { type: "checkbox", disabled: "" },
                                  domProps: {
                                    value: item.gateId,
                                    checked: Array.isArray(_vm.existGateId)
                                      ? _vm._i(_vm.existGateId, item.gateId) >
                                        -1
                                      : _vm.existGateId
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.existGateId,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = item.gateId,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.existGateId = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.existGateId = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.existGateId = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "lbl" })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "gateId" }, [
                              _vm._v(_vm._s(item.gateId))
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "gateModelName",
                                class: {
                                  none: _vm.checkColumnShowHide("productName")
                                }
                              },
                              [_vm._v(_vm._s(item.gateModelName))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "gateName",
                                class: {
                                  none: _vm.checkColumnShowHide("gateName")
                                }
                              },
                              [_vm._v(_vm._s(item.gateName))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "option1",
                                class: {
                                  none: _vm.checkColumnShowHide("option1")
                                }
                              },
                              [_vm._v(_vm._s(item.option1))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "option2",
                                class: {
                                  none: _vm.checkColumnShowHide("option2")
                                }
                              },
                              [_vm._v(_vm._s(item.option2))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn-cus-delete btn-right btn-delete",
                                    attrs: {
                                      href: "#processDelete",
                                      "data-toggle": "modal"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.setTempData(
                                          _vm.tempGroupPassages[item.gateId],
                                          item.gateId
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("解除")]
                                )
                              ]
                            )
                          ]
                        )
                      : _c(
                          "tr",
                          {
                            class: { selected: _vm.rowSelected(item.gateId) },
                            attrs: { id: item.gateId }
                          },
                          [
                            _c("td", { staticClass: "center" }, [
                              _c("label", { staticClass: "pos-rel" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedGateId,
                                      expression: "selectedGateId"
                                    }
                                  ],
                                  staticClass: "ace",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value: item.gateId,
                                    checked: Array.isArray(_vm.selectedGateId)
                                      ? _vm._i(
                                          _vm.selectedGateId,
                                          item.gateId
                                        ) > -1
                                      : _vm.selectedGateId
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.selectedGateId,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = item.gateId,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.selectedGateId = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.selectedGateId = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.selectedGateId = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "lbl" })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "gateId" }, [
                              _vm._v(_vm._s(item.gateId))
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "gateModelName",
                                class: {
                                  none: _vm.checkColumnShowHide("productName")
                                }
                              },
                              [_vm._v(_vm._s(item.gateModelName))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "gateName",
                                class: {
                                  none: _vm.checkColumnShowHide("gateName")
                                }
                              },
                              [_vm._v(_vm._s(item.gateName))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "option1",
                                class: {
                                  none: _vm.checkColumnShowHide("option1")
                                }
                              },
                              [_vm._v(_vm._s(item.option1))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "option2",
                                class: {
                                  none: _vm.checkColumnShowHide("option2")
                                }
                              },
                              [_vm._v(_vm._s(item.option2))]
                            ),
                            _vm._v(" "),
                            _c("td")
                          ]
                        )
                  ])
                })
              ],
              2
            )
          : _c(
              "table",
              {
                staticClass: "table  table-bordered table-hover dataTable",
                attrs: { id: "simple-table" }
              },
              [
                _vm._m(4),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("td", { attrs: { colspan: "6" } }, [
                      _vm._v(_vm._s(_vm.message))
                    ])
                  ])
                ])
              ]
            )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row pd-t-10" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _vm.pages > 0
            ? _c(
                "div",
                { staticClass: "dataTables_paginate paging_simple_numbers" },
                [
                  _c("paginate", {
                    attrs: {
                      "page-count": _vm.pages,
                      "page-range": 3,
                      "margin-pages": 2,
                      "click-handler": _vm.handleCurrentChange,
                      "prev-text": "<<",
                      "next-text": ">>",
                      "container-class": "pagination",
                      "page-class": "page-item"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "process", tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("span", { staticClass: "progress-question" }, [
                _vm._v("チェックしたゲートを追加しますか？")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "progress",
                  class: {
                    "progress-striped": !_vm.success,
                    active: !_vm.success,
                    hide: !_vm.success
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "progress-bar", style: _vm.progressWidth },
                    [
                      _c("span", [
                        _vm._v(_vm._s(Math.round(_vm.progress)) + "%")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.successGate > 0
                ? _c("span", { staticClass: "success-label" }, [
                    _vm._v(
                      _vm._s(_vm.countGate) +
                        "件中" +
                        _vm._s(_vm.successGate) +
                        "件を追加しました。"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errorMessage.length > 0
                ? _c("div", [
                    _c("span", { staticClass: "error-box-title" }, [
                      _vm._v("追加失敗")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "error-box" },
                      [
                        _vm._l(_vm.errorMessage, function(item) {
                          return [
                            _c("p", {
                              key: item,
                              domProps: { innerHTML: _vm._s(item) }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v("OK")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-danger pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { disabled: _vm.isDisabled },
                      on: {
                        click: function($event) {
                          _vm.addGateToGateGroup()
                        }
                      }
                    },
                    [_vm._v("実行")]
                  )
                : _vm._e()
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "processDelete", tabindex: "-1" }
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("span", { staticClass: "progress-delete-question" }, [
                _vm._v(_vm._s(_vm.tempGateId) + "との関連付けを解除しますか？")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-danger pull-right",
                  staticStyle: { width: "100px" },
                  attrs: { "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.deleteGate(_vm.tempRelationId, _vm.tempGateId)
                    }
                  }
                },
                [_vm._v("解除")]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
      _vm._v(" "),
      _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-icon search-box" }, [
      _c("input", {
        staticClass: "nav-search-input",
        attrs: {
          type: "text",
          placeholder: "選択項目にチェックして検索",
          id: "nav-search-input",
          autocomplete: "off"
        }
      }),
      _vm._v(" "),
      _c("i", { staticClass: "ace-icon fa fa-search nav-search-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pull-right" }, [
      _c(
        "a",
        {
          staticClass: "option_button",
          attrs: {
            "data-toggle": "collapse",
            "data-parent": "#accordion",
            href: "#collapseOne",
            "aria-expanded": "false"
          }
        },
        [
          _vm._v("表示オプション \n          "),
          _c("i", {
            staticClass: "bigger-110 ace-icon fa fa-angle-down",
            attrs: {
              "data-icon-hide": "ace-icon fa fa-angle-up",
              "data-icon-show": "ace-icon fa fa-angle-down"
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checkbox table_items" }, [
      _c("label", [
        _c("input", {
          staticClass: "ace",
          attrs: { name: "gateId", type: "checkbox", disabled: "", checked: "" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "lbl" }, [_vm._v("ゲートID")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "center" }, [
          _c("label", { staticClass: "pos-rel" }, [
            _c("input", { staticClass: "ace", attrs: { type: "checkbox" } }),
            _vm._v(" "),
            _c("span", { staticClass: "lbl" })
          ])
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("ゲートID")]),
        _vm._v(" "),
        _c("th", [_vm._v("ゲート名")]),
        _vm._v(" "),
        _c("th", [_vm._v("製品名")]),
        _vm._v(" "),
        _c("th", [_vm._v("備考.1")]),
        _vm._v(" "),
        _c("th", [_vm._v("備考.2")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("ゲートの関連付けを追加")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("関連付け解除")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e5c643be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5c643be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/group/GroupGateAdd.vue
// module id = null
// module chunks = 